// extracted by mini-css-extract-plugin
export default {"modal":"Q8pn8z","message":"OlaOzJ","buttons":"pT50Mn","button":"Vd8hGW"};